import React, { PureComponent } from "react"
import { Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { connect } from "react-redux"
import navigationConfig from "./../configs/menuConfig"
import { getLogo } from "./../helpers/url.helper"
import { Navbar } from "reactstrap"
import './mobileLayout.css'

class MobileLayout extends PureComponent {

    render() {

        if (!this.props.member) {
            return <div style={{ paddingTop: 75 }}>
                {this.props.children}
            </div>

        }

        return (
            <div className="mobile">

                <Navbar className="header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow navbar-light floating-nav navbar navbar-mobile">
                    <div className="navbar-wrapper">
                        <div className="navbar-container content">
                            <div
                                className="navbar-collapse d-flex justify-content-center align-items-center"
                                id="navbar-mobile"
                            >
                                {/*}
              <div className="bookmark-wrapper">
                <NavbarBookmarks
                  sidebarVisibility={props.sidebarVisibility}
                  handleAppOverlay={props.handleAppOverlay}
                />
              </div>
              */}

                                <div className="bookmark-wrapper">
                                    <img src={getLogo(this.props.company)} alt="logo" style={{ maxHeight: 35, marginTop: 20 }} />
                                </div>


                            </div>
                        </div>
                    </div>
                </Navbar>

                <div style={{ paddingTop: 75 }}>
                    {this.props.children}
                </div>

                <div class="nav-wrapper" style={{ height: 44 }}>
                    <nav className="navbar fixed-bottom navbar-light" role="navigation">
                        <Nav className="w-100">
                            <div className=" d-flex flex-row justify-content-around w-100">
                                {
                                    navigationConfig.map(({ id, navLink, title, permission, icon, master }, index) => {
                                        //if (permission && !this.props.company.mobileAppConfig[permission]) return null;
                                        console.log(id);

                                        //if (id == 'notification' && this.props.company.mobileAppConfig.buyLink) {
                                        //    return;
                                        //}


                                        if (id == 'offers') {
                                            return this.props.company.mobileAppConfig.buyLink ? (
                                                <NavItem key={`tab-${index}`}>
                                                    <NavLink onClick={() => this.props.offers()} to={'#'} className={"nav-link " + (master ? 'menu-master' : '')} activeClassName="dad">
                                                        <div className="row d-flex flex-column justify-content-center align-items-center">
                                                            {icon}
                                                            <div>{title}</div>
                                                        </div>
                                                    </NavLink>
                                                </NavItem>
                                            ) : null
                                        }

                                        return (
                                            <NavItem key={`tab-${index}`}>
                                                <NavLink to={navLink} className={"nav-link " + (master ? 'menu-master' : '')} activeClassName="active">
                                                    <div className="row d-flex flex-column justify-content-center align-items-center">
                                                        {icon}
                                                        <div>{title}</div>
                                                    </div>
                                                </NavLink>
                                            </NavItem>
                                        );
                                    })
                                }
                            </div>
                        </Nav>
                    </nav>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        app: state.customizer,
        member: state.main.member,
        company: state.main.company,
    }
}

export default connect(mapStateToProps, {
    logout: () => {
        return dispatch => dispatch({ type: "AUTH_LOGOUT" })
    },
    offers: () => {
        return dispatch => dispatch({ type: "OPEN_OFFERS" })
    },
})(MobileLayout)
